'use strict';

angular.module('app.addNewInfluencerGroup')
	.controller('addNewInfluencerGroupCtrl', ['$scope',  '$rootScope', '$modal', '$modalInstance', 'addNewInfluencerGroupService', 'TRACK_EVENTS',
		function ($scope, $rootScope, $modal, $modalInstance, addNewInfluencerGroupService, TRACK_EVENTS) {

		$scope.influencerGroupName = "";
		$scope.influencerGroupDescription = "";
		$scope.influencerGroupType = null;
		$scope.influencerGroupTypeValues = null;
		$scope.menuvisible = true;
		$scope.conditionListObject = [];
		$scope.projects = [];
		$scope.campaigns = [];
		$scope.selectedAdvertiser = 0;

        if($rootScope.sideMenuSelections.advertiserId != null || $rootScope.sideMenuSelections.advertiserId !== undefined) {
            $scope.selectedAdvertiser = $rootScope.sideMenuSelections.advertiserId;
        } else if($rootScope.currentUser && $rootScope.currentUser.company && $rootScope.currentUser.company.id) {
			$scope.selectedAdvertiser = $rootScope.currentUser.company.id;
		}

		// Sample load data for edit - Should use Html to get the data
		$scope.loadInfluencerGroupData = function (influencerGroupId) {
			addNewInfluencerGroupService.getInfluencerGroupDetails(influencerGroupId, true)
				.then(function(response) {
					$scope.influencerGroupName = response.data.influencer_group_name;
					$scope.influencerGroupDescription = response.data.influencer_group_description;
					$scope.influencerGroupType = response.data.influencer_group_type;
					$scope.influencerGroupTypeValues = response.data.influencer_group_type_values;
					$scope.menuvisible = response.data.menuvisible == 1 ? true : false;
					$scope.conditionListObject = response.data.condition_list_object;

					$scope.allInfluencerGroupTypes.forEach(function(item) {
			            if(item.id == $scope.influencerGroupType) {
			                item.ticked = true;
			            }
			        });

					$scope.influencerGroupTypeValues.forEach(function(valueObject) {
			            $scope.projects.forEach(function(item) {
				            if(item.id == valueObject.id && item.name == valueObject.name) {
				                item.ticked = true;
				            }
				        });
				        $scope.campaigns.forEach(function(item) {
                            if(item.id == valueObject.id && item.name == valueObject.name) {
                                item.ticked = true;
                            }
                        });
				        $scope.topics.forEach(function(item) {
				            if(item.id == valueObject.id && item.name == valueObject.name) {
				                item.ticked = true;
				            }
				        });
				        $scope.verticals.forEach(function(item) {
				            if(item.id == valueObject.id && item.name == valueObject.name) {
				                item.ticked = true;
				            }
				        });
			        });
				}, function(response) {
					var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = response.message;
				})
		}
		
		var definitions = angular.copy($rootScope.definitions);
        $scope.verticals = definitions.verticals;
        $scope.topics = definitions.topics;

        angular.forEach($rootScope.projectsForSelectedAdvertiser, function(project) {
        	$scope.projects.push({
        		id: project.id,
        		name: project.name
        	})
        })

        angular.forEach($rootScope.campaignsForSelectedAdvertiser, function(campaign) {
        	$scope.campaigns.push({
        		id: campaign.campaign_id,
        		name: campaign.campaign_name
        	})
        })

		$scope.allInfluencerGroupTypes = [];
		addNewInfluencerGroupService.getInfluencerGroupTypes(false)
        .then(function(response) {
            $scope.allInfluencerGroupTypes = response.data;

            // Sample
            if($scope.isAddNewInfluencerGroup == false) {
            	$scope.loadInfluencerGroupData($scope.influencerGroupId);
            }
        })	

        $scope.selectInfuencerGroupType = function(data) {
        	$scope.conditionListObject = [];
        	$scope.influencerGroupType = data.id;
        }

	    $scope.closeModal = function() {
	        $modalInstance.close();
	    }

	    $scope.addCondition = function(){
	        var newIndex = $scope.conditionListObject.length;
	        $scope.conditionListObject.push({
	            index: newIndex,
	            selectedConditionOperator: null,
	            selectedConditionType: null,
	            selectedConditionComparision: null,
	            selectedConditionComparisionValue: null
	        });
	    }

	    $scope.save = function() {
	    	// check mention is empty value
	    	for (var i=0; i<$scope.conditionListObject.length; i++) {
	    		if ($scope.conditionListObject[i].selectedConditionType === "keyword" && !$scope.conditionListObject[i].selectedConditionComparisionValue) {
	    			var errorModalInstance = $modal.open({
	    			    scope: $scope,
	    			    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
	    			    windowClass: 'modal-dialog-mention-error'
	    			});
	    			$scope.errorModalInstance = errorModalInstance;
	    			$scope.errorMessage = "Please input mention into empty condition!";
	    			return;
	    		}
	    	}

	    	var params = {
	    		influencerGroupId: $scope.influencerGroupId,
	    		influencerGroupName: $scope.influencerGroupName,
	    		influencerGroupType: $scope.influencerGroupType,
	    		influencerGroupDescription: $scope.influencerGroupDescription,
				companyId: $scope.selectedAdvertiser,
	    		menuvisible: $scope.menuvisible == true ? 1 : 0,
	    		conditionListObject: $scope.conditionListObject,
	    		influencerGroupTypeValues: $scope.influencerGroupTypeValues
	    	}

	    	if($scope.isAddNewInfluencerGroup == true) {
	    		addNewInfluencerGroupService.addNewInfluencerGroup(params, true)
	    			.then(function(response) {
    				    // Mixpanel tracking add influencer group
    				    analytics.track(
    				        TRACK_EVENTS.CREATE_INFLUENCER_GROUP.EVT_NAME,
    				        {	
    				        	"action": "Create",
    				            "item": TRACK_EVENTS.CREATE_INFLUENCER_GROUP.ITEM_NAME,
    				            "target_type": TRACK_EVENTS.CREATE_INFLUENCER_GROUP.ITEM_NAME,
    				            "target_name": params.influencerGroupName,
    				            "params": params
    				        }
    				    );
	    				$scope.closeModal();
	    				$rootScope.$broadcast('reload_influencerGroup', {});
	    				$rootScope.$broadcast('reload_influencerGroupPage', {});
	    			}, function(response) {
	    				var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = response.message;
	    			})
	    	} else {
	    		addNewInfluencerGroupService.updateInfluencerGroup(params, true)
	    			.then(function(response) {
	    				$scope.closeModal();
	    				$rootScope.$broadcast('reload_influencerGroup', {});
	    				$rootScope.$broadcast('reload_influencerGroupPage', {});
	    			}, function(response) {
	    				var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = response.message;
	    			})
	    	}
	    }

	}])